import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import MainPage from './pages/MainPage';
import ResultsPage from './pages/ResultPage';
import './App.css';
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import ProtectedRoute from './components/Services/ProtectedRoute';
import Feedback from './pages/Feedback';
import QueriesModal from './components/QueriesModal/QueriesModal.jsx'
import InstitutionalStatistics from './pages/InstitutionalStatistics.jsx'
import Profile from './pages/Profile.jsx'
import Demo from './pages/DemoPage.jsx'

const App = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkDevice = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkDevice();
        window.addEventListener('resize', checkDevice);
        return () => window.removeEventListener('resize', checkDevice);
    }, []);

    if (isMobile) {
        return (
            <div className="mobile-warning">
                <div className="mobile-warning-content">
                    <img
                        src="https://kesifaraci.com/assets/img/logo.ico"
                        alt="Piri AI Logo"
                        className="warning-logo-top"
                    />
                    <h1>Masaüstü Versiyonunu Kullanın</h1>
                    <p>Piri AI şu anda sadece masaüstü tarayıcılarda kullanılabilir.</p>
                    <p>Lütfen bir masaüstü veya dizüstü bilgisayardan erişim sağlayın.</p>
                </div>
            </div>
        );
    }

    return (
        <Router>
            <div className="app-container">
                <Routes>
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/register" element={<RegisterPage />} />
                      <Route path="/demo" element={<Demo />} />

                    <Route
                        path="/"
                        element={
                            <ProtectedRoute>
                                <MainPage />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/results"
                        element={
                            <ProtectedRoute>
                                <ResultsPage />
                            </ProtectedRoute>
                        }
                    />
                    <Route path='/feedback' element={<Feedback />}  />
                    <Route path='/sorgularim' element={<QueriesModal />} />
                    <Route path='/kurumsalIstatistikler' element={<InstitutionalStatistics />} />
                    <Route
                        path="/profile"
                        element={
                            <ProtectedRoute>
                                <Profile />
                            </ProtectedRoute>
                        }
                    />
                </Routes>
            </div>
        </Router>
    );
};

export default App;